import { Button, Menu } from "antd";
import { changeRoute } from "common/utils/changeRoute";
import { bool, func, instanceOf } from "prop-types";
import React from "react";
import Logout from "assets/images/logout-purple.svg";
import PoliciesActions from "services/policies/actions";

const MenuResponsive = ({ profile, history, dispatch, t, logout, handleCloseModal, styleDark }) => (
  <Menu>
    <Menu.Item
      key="Status-Information"
      className="header__dropdown-custom__item header__dropdown-custom__item--hasAfter user-item"
    >
      <p className="body-bold title-name">{profile?.user?.person?.name}</p>
      <div className="box-flex">
        <div className="box-flex__column">
          <p className="header__dropdown-custom__itemState--label">{t("label.onlineStatus")}</p>
          <p className="header__dropdown-custom__itemState">
            <span className="header__dropdown-custom__itemState__circle" />
            {t("label.inLine")}
          </p>
        </div>
        <Button
          className="button-mode-dark"
          onClick={() => {
            dispatch(PoliciesActions.styleDark());
            handleCloseModal();
          }}
        >
          Modo Oscuro
          {styleDark ? (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 7.27273C11.5 7.27273 12.7273 8.5 12.7273 10C12.7273 11.5 11.5 12.7273 10 12.7273C8.5 12.7273 7.27273 11.5 7.27273 10C7.27273 8.5 8.5 7.27273 10 7.27273ZM10 5.45455C7.49091 5.45455 5.45455 7.49091 5.45455 10C5.45455 12.5091 7.49091 14.5455 10 14.5455C12.5091 14.5455 14.5455 12.5091 14.5455 10C14.5455 7.49091 12.5091 5.45455 10 5.45455ZM0.909091 10.9091H2.72727C3.22727 10.9091 3.63636 10.5 3.63636 10C3.63636 9.5 3.22727 9.09091 2.72727 9.09091H0.909091C0.409091 9.09091 0 9.5 0 10C0 10.5 0.409091 10.9091 0.909091 10.9091ZM17.2727 10.9091H19.0909C19.5909 10.9091 20 10.5 20 10C20 9.5 19.5909 9.09091 19.0909 9.09091H17.2727C16.7727 9.09091 16.3636 9.5 16.3636 10C16.3636 10.5 16.7727 10.9091 17.2727 10.9091ZM9.09091 0.909091V2.72727C9.09091 3.22727 9.5 3.63636 10 3.63636C10.5 3.63636 10.9091 3.22727 10.9091 2.72727V0.909091C10.9091 0.409091 10.5 0 10 0C9.5 0 9.09091 0.409091 9.09091 0.909091ZM9.09091 17.2727V19.0909C9.09091 19.5909 9.5 20 10 20C10.5 20 10.9091 19.5909 10.9091 19.0909V17.2727C10.9091 16.7727 10.5 16.3636 10 16.3636C9.5 16.3636 9.09091 16.7727 9.09091 17.2727ZM4.53636 3.25455C4.45226 3.17027 4.35236 3.10341 4.24239 3.05779C4.13241 3.01217 4.01452 2.98869 3.89545 2.98869C3.77639 2.98869 3.6585 3.01217 3.54852 3.05779C3.43855 3.10341 3.33865 3.17027 3.25455 3.25455C3.17027 3.33865 3.10341 3.43855 3.05779 3.54852C3.01217 3.6585 2.98869 3.77639 2.98869 3.89545C2.98869 4.01452 3.01217 4.13241 3.05779 4.24239C3.10341 4.35236 3.17027 4.45226 3.25455 4.53636L4.21818 5.5C4.57273 5.85455 5.15455 5.85455 5.5 5.5C5.84545 5.14545 5.85455 4.56364 5.5 4.21818L4.53636 3.25455ZM15.7818 14.5C15.6977 14.4157 15.5978 14.3489 15.4878 14.3032C15.3779 14.2576 15.26 14.2341 15.1409 14.2341C15.0218 14.2341 14.904 14.2576 14.794 14.3032C14.684 14.3489 14.5841 14.4157 14.5 14.5C14.4157 14.5841 14.3489 14.684 14.3032 14.794C14.2576 14.904 14.2341 15.0218 14.2341 15.1409C14.2341 15.26 14.2576 15.3779 14.3032 15.4878C14.3489 15.5978 14.4157 15.6977 14.5 15.7818L15.4636 16.7455C15.8182 17.1 16.4 17.1 16.7455 16.7455C16.8297 16.6614 16.8966 16.5615 16.9422 16.4515C16.9878 16.3415 17.0113 16.2236 17.0113 16.1045C17.0113 15.9855 16.9878 15.8676 16.9422 15.7576C16.8966 15.6476 16.8297 15.5477 16.7455 15.4636L15.7818 14.5ZM16.7455 4.53636C16.8297 4.45226 16.8966 4.35236 16.9422 4.24239C16.9878 4.13241 17.0113 4.01452 17.0113 3.89545C17.0113 3.77639 16.9878 3.6585 16.9422 3.54852C16.8966 3.43855 16.8297 3.33865 16.7455 3.25455C16.6614 3.17027 16.5615 3.10341 16.4515 3.05779C16.3415 3.01217 16.2236 2.98869 16.1045 2.98869C15.9855 2.98869 15.8676 3.01217 15.7576 3.05779C15.6476 3.10341 15.5477 3.17027 15.4636 3.25455L14.5 4.21818C14.1455 4.57273 14.1455 5.15455 14.5 5.5C14.8545 5.84545 15.4364 5.85455 15.7818 5.5L16.7455 4.53636ZM5.5 15.7818C5.58428 15.6977 5.65114 15.5978 5.69676 15.4878C5.74238 15.3779 5.76586 15.26 5.76586 15.1409C5.76586 15.0218 5.74238 14.904 5.69676 14.794C5.65114 14.684 5.58428 14.5841 5.5 14.5C5.4159 14.4157 5.316 14.3489 5.20602 14.3032C5.09605 14.2576 4.97815 14.2341 4.85909 14.2341C4.74003 14.2341 4.62214 14.2576 4.51216 14.3032C4.40218 14.3489 4.30229 14.4157 4.21818 14.5L3.25455 15.4636C2.9 15.8182 2.9 16.4 3.25455 16.7455C3.60909 17.0909 4.19091 17.1 4.53636 16.7455L5.5 15.7818Z"
                fill="#5D30DD"
              />
            </svg>
          ) : (
            <svg
              width="15"
              height="21"
              viewBox="0 0 15 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.29361 2.73267C9.54138 2.73267 12.9993 6.32267 12.9993 10.7327C12.9993 15.1427 9.54138 18.7327 5.29361 18.7327C4.96611 18.7327 4.63862 18.7127 4.32076 18.6627C6.1605 16.5027 7.22003 13.6827 7.22003 10.7327C7.22003 7.78267 6.1605 4.96267 4.32076 2.80267C4.63862 2.75267 4.96611 2.73267 5.29361 2.73267ZM5.29361 0.732666C3.54056 0.732666 1.89346 1.23267 0.477539 2.08267C3.35755 3.81267 5.29361 7.03267 5.29361 10.7327C5.29361 14.4327 3.35755 17.6527 0.477539 19.3827C1.89346 20.2327 3.54056 20.7327 5.29361 20.7327C10.6105 20.7327 14.9257 16.2527 14.9257 10.7327C14.9257 5.21267 10.6105 0.732666 5.29361 0.732666Z"
                fill="#5D30DD"
              />
            </svg>
          )}
        </Button>
      </div>
    </Menu.Item>
    <div className="title-section">
      <p className="body-bold">Perfil</p>
    </div>
    <Menu.Item key="My-Page-item" className="header__dropdown-custom__item">
      <Button
        type="link"
        id="edit-page-button-header"
        block
        onClick={() => {
          changeRoute("editPage", history, dispatch);
          handleCloseModal();
        }}
      >
        Mi página
      </Button>
    </Menu.Item>
    <div className="title-section">
      <p className="body-bold">Configuraciones</p>
    </div>
    <Menu.Item key="Manage-Connection-item" className="header__dropdown-custom__item">
      <Button
        type="link"
        id="edit-page-button-header"
        block
        onClick={() => {
          changeRoute("account/pia", history, dispatch);
          handleCloseModal();
        }}
      >
        Gestionar conexiones
      </Button>
    </Menu.Item>
    <Menu.Item key="Account-item" className="header__dropdown-custom__item">
      <Button
        type="link"
        id="edit-page-button-header"
        block
        onClick={() => {
          changeRoute("account", history, dispatch);
          handleCloseModal();
        }}
      >
        Cuenta
      </Button>
    </Menu.Item>
    <Menu.Item className="header__dropdown-custom__item header__dropdown-custom__item--logOut">
      <Button
        type="link"
        id="logout-button-header"
        block
        onClick={(e) => {
          e.preventDefault();
          history.replace("/");
          logout();
        }}
      >
        <img className="header-logout" src={Logout} alt="logout" />
        {t("label.logOut")}
      </Button>
    </Menu.Item>
  </Menu>
);

MenuResponsive.propTypes = {
  profile: instanceOf(Object),
  history: instanceOf(Object).isRequired,
  dispatch: func.isRequired,
  handleCloseModal: func.isRequired,
  t: func.isRequired,
  logout: func.isRequired,
  styleDark: bool.isRequired,
};

MenuResponsive.defaultProps = {
  profile: undefined,
};

export default MenuResponsive;
